import '@loyal_template/password.css'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import { Alert, Button, Input } from 'loyal-react'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import TitlePrint from 'App/Shell/TitlePrint'
const errors = {
  InternalErrorException: 'Erro ao validar o token. Tente novamente!',
  ErrorToken: 'Erro ao enviar o token. Tente novamente!'
}

const successMsg = {
  SuccessToken: 'Token enviado com sucesso.',
  SuccessConfirm: 'E-mail alterado com sucesso.'
}

const timerDefault = 180

class TokenChangeEmail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      expiredTime: false,
      token: { value: '' },
      isValidToken: false,
      isLoadingToken: true,
      email: { value: '' },
      isValidEmail: false,
      isLoading: false,
      transactionId: null,
      error: null,
      success: null,
      disableVerifyInput: true,
      phone: this.props.userInfo.phone_number.replace('+55', ''),
      name: this.props.userInfo.name,
      documentNumber: this.props.userInfo.username,
      timeLeft: timerDefault,
      test: null
    }
    this.confirmToken = this.confirmToken.bind(this)
    this.sendTokenAgain = this.sendTokenAgain.bind(this)
  }

  go = () => {
    this.sendToken()
    this.startTimer()
  }

  countDown () {
    this.setState({ timeLeft: this.state.timeLeft - 1 })
    if (this.state.timeLeft === 0) {
      clearInterval(this.state.timer)
      this.setState({ expiredTime: true })
    }
  }

  startTimer = () => {
    this.setState({
      timer: setInterval(() => {
        this.countDown()
      }, 1000)
    })
  }

  toSeconds = seconds => {
    return [parseInt((seconds / 60) % 60), parseInt(seconds % 60)]
      .join(':')
      .replace(/\b(\d)\b/g, '0$1')
  }

  componentDidMount () {
    this.go()
  }

  sendToken = () => {
    this.setState({
      isLoadingToken: true
    })

    const handleSuccess = response => {
      setTimeout(() => {
        if (response.type === 'SEND_TOKEN_PHONE_SUCCESS') {
          var transactionId = this.props.dataResponse
          this.setState({
            transactionId: transactionId,
            isLoadingToken: false,
            timeLeft: timerDefault,
            expiredTime: false,
            disableVerifyInput: false
          })
        } else {
          this.setState({
            success: false,
            isLoadingToken: false,
            expiredTime: true,
            error: { msg: errors.ErrorToken }
          })
        }
      }, 500)
    }
    const { phone, name, documentNumber } = this.state
    const data = {
      contact: phone,
      name: name,
      documentNumber: documentNumber
    }
    this.props
      .fetchSendTokenPhone(data)
      .then(handleSuccess)
  }

  sendTokenAgain = () => {
    this.closeAlert()
    this.setState({
      isLoadingToken: true
    })

    const handleSuccess = response => {
      setTimeout(() => {
        if (response.type === 'SEND_TOKEN_PHONE_SUCCESS') {
          var transactionId = this.props.dataResponse
          this.setState({
            transactionId: transactionId,
            isLoadingToken: false,
            timeLeft: timerDefault,
            expiredTime: false,
            disableVerifyInput: false,
            success: { msg: successMsg.SuccessToken }
          })
          this.startTimer()
        } else {
          this.setState({
            success: false,
            isLoadingToken: false,
            expiredTime: true,
            error: { msg: errors.ErrorToken }
          })
        }
      }, 500)
    }

    const { phone, name, documentNumber } = this.state
    const data = {
      contact: phone,
      name: name,
      documentNumber: documentNumber
    }
    this.props
      .fetchSendTokenPhone(data)
      .then(handleSuccess)
  }

  confirmToken = () => {
    this.closeAlert()
    this.setState({
      isLoading: true
    })

    const { phone, documentNumber, transactionId, token, email } = this.state

    const handleSuccess = response => {
      setTimeout(() => {
        if (response.type === 'TOKEN_CHAGE_EMAIL_SUCCESS') {
          this.setState({
            isLoading: false,
            isValidToken: false,
            isValidEmail: false,
            disableVerifyInput: true,
            error: null,
            success: { msg: successMsg.SuccessConfirm }
          })
          this.props.fetchParticipant()
          this.clearAllInput()
          setTimeout(() => {
            this.redirect()
          }, 3000)
        } else {
          this.setState({
            success: false,
            isLoading: false,
            isValidToken: false,
            isValidEmail: false,
            error: { msg: errors.InternalErrorException }
          })
          this.clearAllInput()
        }
      }, 500)
    }

    const data = {
      documentNumber: documentNumber,
      email: email.value,
      phone: phone,
      token: token.value,
      transactionId: transactionId.data
    }
    this.props
      .fetchTokenChangeEmail(data)
      .then(handleSuccess)
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.confirmToken()
    }
  }

  onChangeToken = (e) => {
    this.setState({ token: { value: e.target.value } }, () => this.isValidToken())
  }

  onChangeEmail = (e) => {
    this.setState({ email: { value: e.target.value } }, () => this.isValidEmail())
  }

  maskPhone = (phone) => {
    let tel = phone.replace('+55', '')
    let maskedTel = ''
    let idx = 0
    for (let d of tel) {
      if (idx === 0) {
        maskedTel += '('
      }

      if (idx === 2) {
        maskedTel += ') '
      }

      if (idx === 7) {
        maskedTel += '-'
      }

      if (idx >= 2 && idx <= 6) {
        maskedTel += '*'
      } else {
        maskedTel += d
      }
      idx++
    }
    return maskedTel
  }

  isValidToken = () => {
    let isValidToken = false
    const tokenValidator = /^[0-9]{6}$/
    const { token } = this.state
    if (!tokenValidator.test(token.value)) {
      this.setState({
        token: {
          value: token.value,
          error: 'Digite um token válido'
        }
      })
      isValidToken = false
      this.setState({ disableVerifyButton: true })
    } else {
      this.setState({
        token: {
          value: token.value,
          error: ''
        }
      })
      isValidToken = true
    }
    this.setState({ isValidToken })
  }

  isValidEmail = () => {
    let isValidEmail = false
    const emailValidator = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/
    const { email } = this.state
    if (!emailValidator.test(email.value)) {
      this.setState({
        email: {
          value: email.value,
          error: 'Digite um e-mail válido'
        }
      })
      isValidEmail = false
      this.setState({ disableVerifyButton: true })
    } else {
      this.setState({
        email: {
          value: email.value,
          error: ''
        }
      })
      isValidEmail = true
    }
    this.setState({ isValidEmail })
  }

  isInputEmpty = () => {
    if (!this.state.isValidEmail || !this.state.isValidToken) {
      return true
    }
  }

  clearAllInput () {
    this.setState({ token: { value: '' } })
    this.setState({ email: { value: '' } })
  }

  redirect () {
    this.props.history.push('/security-access')
  }

  closeAlert = () => this.setState({ error: null, success: null })

  render () {
    return (
      <Fragment>
        <TitlePrint page={'Minha senha'} />
        <div className='container-fluid px-0 bg-ui-4'>
          <div className='container py-4'>
            <div className='row'>
              <LoggedSidebar selected='/security-access' count={0} />
              <div className='col-12 col-xl-8 mt-0'>
                <div className='row'>
                  {this.state.error && <Alert
                    isError
                    title={this.state.error.msg}
                    className='pb-2'
                    onClose={this.closeAlert}
                  />}
                  {this.state.success && <Alert
                    title={this.state.success.msg}
                    className='pb-2'
                    onClose={this.closeAlert}
                  />}
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
                      <section className='col mr-auto'>
                        <h1 className='txt-title txt-font-body txt-initial color-title mr-auto' tabIndex={0}>
                          Altere seu e-mail aqui
                        </h1>
                      </section>
                    </div>
                    <div className='col-12 mt-2 ml-0 mb-0 px-0'>
                      <p className='ml-1'>
                        <span tabIndex={0}>enviamos um código via SMS para o seu telefone: <strong className='color-brand-1-acce'> {this.maskPhone(this.props.userInfo.phone_number)} </strong></span>
                        <br />
                        <span tabIndex={0} className='d-block mb-2'>por favor, digite o código no campo abaixo.</span>
                      </p>
                      <div className='col-12 d-flex mb-0 px-0'>
                        <div className='col-6 px-0' tabIndex={0}>
                          <Input
                            id='txt-token-confirm'
                            name='code'
                            label='código de verificação'
                            className='col-12 col-md-12'
                            required
                            value={this.state.token.value}
                            onChange={this.onChangeToken}
                            valid={this.state.isValidToken}
                            data-error={this.state.token.error}
                            disabled={this.state.disableVerifyInput}
                            mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                          />
                        </div>
                        <div className='col-6'>
                          <Button
                            className='btn-heigth-pros btn-especific btn-reenviar mr-1 height50'
                            type='button'
                            text={this.state.expiredTime ? 'Reenviar' : `Reenviar em ${this.toSeconds(this.state.timeLeft)}`}
                            onClick={this.sendTokenAgain}
                            loading={this.state.isLoadingToken}
                            disabled={!this.state.expiredTime}
                            tabIndex={0}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-12 d-flex mb-1 justify-content-center'>
                      <div className='row col-12 px-0 pb-2 pt-half border-bottom border-color-ui-3' />
                    </div>
                    <div className='col-12 pl-0'>
                      <span className='txt-font-body txt-initial color-ui-2 d-block mb-2 ml-1 mt-3' tabIndex={0}>e agora, digite seu novo e-mail.</span>
                    </div>
                    <div className='col-12 d-flex mb-2 px-0'>
                      <div className='col-6 px-0' tabIndex={0}>
                        <Input
                          id='txt-email'
                          name='email'
                          label='Novo e-mail'
                          className='col-12 col-md-12'
                          required
                          value={this.state.email.value}
                          onChange={this.onChangeEmail}
                          valid={this.state.isValidEmail}
                          data-error={this.state.email.error}
                          disabled={this.state.disableVerifyInput}
                          onKeyPress={this.handleKeyPress}
                          maxLength='100'
                        />
                      </div>
                      <div className='col-6' tabIndex={0}>
                        <Button
                          id={'btn-send-sms-verification'}
                          name={'btn-send-sms-verification'}
                          className='btn-sm btn-featured btn-continuar-sg border btn-heigth-pros border-color-ui-3 mr-1 height50'
                          type='button'
                          text='continuar'
                          disabled={this.isInputEmpty()}
                          onClick={this.confirmToken}
                          loading={this.state.isLoading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

TokenChangeEmail.propTypes = {
  userInfo: PropTypes.object,
  fetchSendTokenPhone: PropTypes.func,
  fetchTokenChangeEmail: PropTypes.func,
  fetchParticipant: PropTypes.func,
  dataResponse: PropTypes.object,
  history: PropTypes.object
}

export default TokenChangeEmail



// WEBPACK FOOTER //
// ./src/Participant/TokenChangeEmail/TokenChangeEmail.js